import React, { useState, useEffect, useRef } from 'react'
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

import { Action } from '../Action'; 

import './fluid-slider.css'

export const FluidSlider = ({ heroContent, autoplayInterval = 8000 }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [fadeOut, setFadeOut] = useState(false);
    const [isNext, setIsNext] = useState(true);
    const [targetIndex, setTargetIndex] = useState(null);
    const [autoplayPaused, setAutoplayPaused] = useState(false);
    const touchStartX = useRef(0);
    const touchEndX = useRef(0);

    useEffect(() => {
        let timeout;
        if (fadeOut) {
            setCurrentIndex((prevIndex) =>
                targetIndex !== null ? targetIndex : (isNext ? (prevIndex + 1) % heroContent.length : (prevIndex - 1 + heroContent.length) % heroContent.length)
            );
            setFadeOut(false);
            setTargetIndex(null);
        }
        return () => clearTimeout(fadeOut);
    }, [fadeOut, isNext, heroContent.length, targetIndex]);

    useEffect(() => {
        const isMobileDevice = () => {
            const userAgent = navigator.userAgent.toLowerCase();
            return userAgent.match(/android|webos|iphone|ipad|ipod|blackberry|windows phone/i);
        };
    
        const interval = setInterval(() => {
            if (!autoplayPaused && !isMobileDevice()) {
                setIsNext(true);
                setFadeOut(true);
            }
        }, autoplayInterval);
    
        return () => clearInterval(interval);
    }, [autoplayInterval, autoplayPaused]);

    const goToNextSlide = () => {
        setIsNext(true);
        setFadeOut(true);
    };

    const goToPrevSlide = () => {
        setIsNext(false);
        setFadeOut(true);
    };

    const goToSlide = (index) => {
        setIsNext(index > currentIndex);
        setTargetIndex(index);
        setFadeOut(true);
    };

    const handleTouchStart = (e) => {
        touchStartX.current = e.changedTouches[0].screenX;
    };

    const handleTouchEnd = (e) => {
        touchEndX.current = e.changedTouches[0].screenX;
        handleSwipeGesture();
    };

    const handleMouseDown = (e) => {
        touchStartX.current = e.screenX;
    };

    const handleMouseUp = (e) => {
        touchEndX.current = e.screenX;
        handleSwipeGesture();
    };

    const handleSwipeGesture = () => {
        if (touchStartX.current - touchEndX.current > 50) {
            goToNextSlide();
        }

        if (touchEndX.current - touchStartX.current > 50) {
            goToPrevSlide();
        }
    };

    const handleContentHoverEnter = () => {
        setAutoplayPaused(true);
    };

    const handleContentHoverLeave = () => {
        setAutoplayPaused(false);
    };

    return (
        <div
            className='relative fluid-slider'
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
        >
            {/* <button onClick={goToPrevSlide} className='nav-button custom-prev'>Previous</button> */}
            <div className={`custom-slider ${fadeOut ? 'fade-out' : ''}`}>
                <div key={currentIndex} className='slide'>
                    <img src={heroContent[currentIndex].backgroundImage.gatsbyImageData.images.fallback.src} alt={heroContent[currentIndex].title || 'Slide Media'} />
                    <div className='grid col-3 col-1-lg gap-10 text-white' onMouseEnter={handleContentHoverEnter} onMouseLeave={handleContentHoverLeave}>
                        <div></div>
                        <div></div>
                        <div className='content'>
                            <h1>{heroContent[currentIndex].title}</h1>
                            {documentToReactComponents(JSON.parse(heroContent[currentIndex].content.raw))}
                            <Action hasButtonConfiguration={heroContent[currentIndex].titleLink !== null} actionData={{
                                buttonLink:heroContent[currentIndex].titleLink,
                                isNoFollow:heroContent[currentIndex].isNoFollow,
                                buttonName:heroContent[currentIndex].buttonName
                            }} isArray={false} />
                        </div>  
                    </div>
                </div>
            </div>
            {/* <button onClick={goToNextSlide} className='nav-button custom-next'>Next</button> */}
            <div className="dots-container">
                {heroContent.map((_, index) => (
                    <button
                        key={index}
                        className={`dot ${index === currentIndex ? 'active' : ''}`}
                        onClick={() => goToSlide(index)}
                    />
                ))}
            </div>
        </div>
    );
};
